import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useCallback, useState } from 'react';
import { ViewStyles } from '@bubble-ui/primitive-view';
import elementRectObserver from 'element-rect-observer';
var Layout = _ref => {
  var {
    children,
    debounceOnRequestAnimationFrame = false,
    id,
    onKeyDown,
    onResize,
    style,
    tabIndex,
    UNSAFE_containerProps
  } = _ref;
  var [dimensions, setDimensions] = useState({
    width: 0,
    height: 0
  });
  var onRef = useCallback(domElement => {
    var stopObserving = null;
    if (domElement != null) {
      stopObserving = elementRectObserver(domElement, _ref2 => {
        var {
          width,
          height
        } = _ref2;
        var dimensions = {
          width,
          height
        };
        if (typeof onResize === 'function') {
          onResize(dimensions);
        } else {
          setDimensions(dimensions);
        }
      }, debounceOnRequestAnimationFrame);
    } else if (stopObserving) {
      // @ts-expect-error need to fix
      stopObserving();
    }
  }, [debounceOnRequestAnimationFrame, setDimensions, onResize]);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id
  }, UNSAFE_containerProps, {
    onKeyDown: onKeyDown,
    ref: onRef,
    style: _objectSpread(_objectSpread({}, ViewStyles), style),
    tabIndex: tabIndex
  }), children(dimensions));
};
Layout.displayName = 'Layout';
export { Layout };
//# sourceMappingURL=Layout.js.map